import React from 'react';

/**
 * Default parent widgets context should be an empty array, and then each widget should concatenate itself onto the
 * array of parents.
 */
const ParentWidgetsContext = React.createContext([]);
export default ParentWidgetsContext;
